import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import constantMessage from '@/helpers/constantMessage';

const state = {
  isMobile: false,
  theme: 'dark',
  layout: 'side',
  systemName: 'Cinepolis',
  copyright: '2020 Cinepolis',
  systemLogo: require('@/assets/logo/logo.png'),
  systemSmallLogo: require('@/assets/logo/logo.png'),
  systemLogoDark: require('@/assets/logo/logo.png'),
  footerLinks: [
    { link: 'link', name: 'Pro' },
    { link: 'link', icon: 'github' },
    { link: 'https://ant.design', name: 'Ant Design' }
  ],
  multipage: false
};

const mutations = {
  setDevice(state, isMobile) {
    state.isMobile = isMobile
  },
  setTheme(state, theme) {
    state.theme = theme
  },
  setLayout(state, layout) {
    state.layout = layout
  },
  setMultipage(state, multipage) {
    state.multipage = multipage
  }
};

const actions = {
  showAdminErrorMessage: async ({ dispatch, commit, state }, payload) => {
    message.error(
      payload['message'] || constantMessage.AdminError,
      payload['time'] || 4
    );
  },
  showAdminSuccessMessage: async ({ dispatch, commit, state }, payload) => {
    message.success(
      payload['message'] || constantMessage.AdminError,
      payload['time'] || 4
    );
  },
  showDevErrorMessage: async ({ dispatch, commit, state }, payload) => {
    process.env.NODE_ENV === 'development' ? message.error(
      payload['message'] || constantMessage.AdminError,
      payload['time'] || 4
    ) : undefined
  },
  showDevSuccessMessage: async ({ dispatch, commit, state }, payload) => {
    process.env.NODE_ENV === 'development' ? message.success(
      payload['message'] || constantMessage.AdminError,
      payload['time'] || 4
    ) : undefined
  },
  showErrorNotification: async ({ dispatch, commit, state }, payload) => {
    notification.error({
      message: 'Oops!',
      description: payload || constantMessage.AdminError
    });
  },
  showSuccessNotification: async ({ dispatch, commit, state }, payload) => {
    notification.success({
      message: 'Success',
      description: payload || constantMessage.AdminError
    });
  },
  showDevErrorNotification: async ({ dispatch, commit, state }, payload) => {
    process.env.NODE_ENV === 'development' ? notification.error({
      message: 'Oops!',
      description: payload || constantMessage.AdminError
    }) : undefined
  },
  showDevSuccessNotification: async ({ dispatch, commit, state }, payload) => {
    process.env.NODE_ENV === 'development' ? notification.success({
      message: 'Success',
      description: payload || constantMessage.AdminError
    }) : undefined
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};